import type {BasePanel} from '@Components/panel/panel.types';

export interface HomepageAiFeaaturesPanelProps extends BasePanel {
  onClickAiImageGenerator?: VoidFunction;
  onClickAiWriter?: VoidFunction;
  onClickAiBgRemover?: VoidFunction;
}

export const PANEL_ID = 'homepage-ai-features-panel';
